const dateFormattedRegex = /\d{2}.\d{2}.\d{4}/

export const isDateFormatted = (date: string): boolean => dateFormattedRegex.test(date)
